export default "__VITE_ASSET__2acd4794__"